import { render, staticRenderFns } from "./ProfilePhoto.vue?vue&type=template&id=ba0abed6&scoped=true"
import script from "./ProfilePhoto.vue?vue&type=script&lang=js"
export * from "./ProfilePhoto.vue?vue&type=script&lang=js"
import style0 from "./ProfilePhoto.vue?vue&type=style&index=0&id=ba0abed6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba0abed6",
  null
  
)

export default component.exports